import {
  IGroupSchedule,
  IMappedGroupScheduleWithoutDate,
  mappedGroupScheduleWithoutDate,
} from 'entities/types';
import {
  dicsiplTypeToPrettyFormat,
  getTagsFromDayDate,
  isNeedToShowByWeekParityAndDateTime,
  locationToPrettyFormat,
  makeHash,
  WeekParity,
} from 'shared/lib';

export const mapGroupScheduleWithoutDate = (
  data: IGroupSchedule[],
): mappedGroupScheduleWithoutDate => {
  const scheduleWeekDays = [1, 2, 3, 4, 5, 6];
  const scheduleMatrix: mappedGroupScheduleWithoutDate = [];

  scheduleWeekDays.forEach((dayNum, index) => {
    if (!scheduleMatrix[index]) {
      scheduleMatrix[index] = [];
    }

    const schedule = data.filter((schedule) => +schedule.daynum === dayNum);

    let mapped: IMappedGroupScheduleWithoutDate;

    if (schedule.length) {
      schedule.forEach((item, i) => {
        mapped = {
          isEven: isNeedToShowByWeekParityAndDateTime({
            weekParity: WeekParity.Even,
            dayDate: item.daydate,
          }),
          dayDate: item.daydate,
          dayNum: +item.daynum,
          disciplName: item.disciplname,
          disciplType: dicsiplTypeToPrettyFormat(item.discipltype),
          disciplTime: item.daytime,
          location: locationToPrettyFormat({
            buildNum: item.building,
            audNum: item.auditory,
          }),
          department: item.kafTitle,
          dateDayTags: getTagsFromDayDate(item.daydate),
          teacher: item.prepodfio,
          key: makeHash(
            i.toString() +
              item.disciplname +
              item.daytime +
              item.dayname +
              item.prepodID +
              item.daydate,
          ),
        };
        scheduleMatrix[index].push(mapped);
      });
    }
  });
  return scheduleMatrix;
};
